import { render, staticRenderFns } from "./headerNativation.vue?vue&type=template&id=6e7b68d8&scoped=true&"
import script from "./headerNativation.vue?vue&type=script&lang=js&"
export * from "./headerNativation.vue?vue&type=script&lang=js&"
import style0 from "./headerNativation.vue?vue&type=style&index=0&id=6e7b68d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7b68d8",
  null
  
)

export default component.exports